export default __webpack_public_path__ + "static/media/warningImage.13338b3e.png";